module.exports = "https://cdn.realtymogul.com/static/media/icon_income.2ddc64cb.svg";